import React from 'react'
import { colors } from '../../../../../Components/consts'
import { Head2 } from '../../../../../Components/Typography/Text.styles'
import { SubHeader, TeamRosterPanelContainer } from '../styles'
import { Coaches } from './Coaches/Coaches'
import { RosterSection } from './RosterSection'
import {
  ASGTeamIds,
  ROSTER_SECTIONS,
  TEAM_ROSTER_LAYOUT,
  WLLASGTeamIds,
} from '../../../../../Constant'
import { StarFilled } from '../../../../../Components/Icons'
import { isPLLASG } from 'Utils/AllStar/allStarHelper'

type TeamRosterPanelProps = {
  team: ASGTeamIds | WLLASGTeamIds
}

export const TeamRosterPanel: React.FC<TeamRosterPanelProps> = ({ team }) => {
  return (
    <TeamRosterPanelContainer>
      {isPLLASG(team) && (
        <SubHeader>
          <StarFilled fill={colors.yellow} width={15} />
          <p>: Career All-Star Selections</p>
        </SubHeader>
      )}
      <>
        <Head2 justify="center" textColor={colors.gray.gray20}>
          Coaches
        </Head2>
        <div className="rosterSection">
          <Coaches team={team} />
        </div>
      </>

      <div className="rosterSection">
        {/* WLL */}
        {!isPLLASG(team) && (
          <RosterSection
            key={ROSTER_SECTIONS.ROSTERS}
            section={ROSTER_SECTIONS.ROSTERS}
            team={team}
            side="left"
            showTitle={false}
            league={'WLL'}
          />
        )}

        {/* PLL */}
        {isPLLASG(team) && (
          <div className="leftColumn">
            {TEAM_ROSTER_LAYOUT.LEFT_COLUMN.map((section) => (
              <RosterSection
                key={section}
                section={isPLLASG(team) ? section : ROSTER_SECTIONS.ROSTERS}
                team={team}
                side="left"
                showTitle={isPLLASG(team)}
                league={isPLLASG(team) ? 'PLL' : 'WLL'}
              />
            ))}
          </div>
        )}
        {isPLLASG(team) && (
          <div className="rightColumn">
            {TEAM_ROSTER_LAYOUT.RIGHT_COLUMN.map((section) => (
              <RosterSection
                key={section}
                section={section}
                team={team}
                side="right"
                showTitle={true}
                league="PLL"
              />
            ))}
          </div>
        )}
      </div>
    </TeamRosterPanelContainer>
  )
}
